import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Text';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "text"
    }}>{`Text`}</h1>
    <p>{`Responsive typography component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Text
  fontSize={[ 3, 4, 5 ]}
  fontWeight='bold'
  color='primary'>
  Text
</Text>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      